import { ALLOW_EDIT } from '../../../utils/OperationPermissions';

const ProductMinMax = {
  type: 'MinMaxCalculationParametersInput',
  title: 'Calculate Product Min/Max Levels',
  formTitle: 'Calculate Product Min/Max Levels',
  formUrl: '/Products/MinMaxLevels/',
  screenReference: 'PRODUCTS_MINMAX',
  operations: ALLOW_EDIT,
  returnUrl: '/menu/Products',
};

export default ProductMinMax;
